import { getGraphQLClient } from 'utils/graphQL/client';
import { UPDATE_STORAGE_METERING_RATE, UPDATE_STORAGE_METERING_FREE_DAYS, } from 'utils/graphQL/mutations/meteringService';
import { GET_METERINGS, GET_METERED_ACCESSORIALS, } from 'utils/graphQL/queries/meteringService';
const MeteringClient = getGraphQLClient({
    url: METERING_SERVICE_URL,
});
export async function updateStorageMeteringRate(data) {
    try {
        return await MeteringClient.mutate({
            mutation: UPDATE_STORAGE_METERING_RATE,
            variables: data,
        });
    }
    catch (e) {
        console.error('Error during updating Storage Metering Rate: ', e.message);
        return { error: e };
    }
}
export async function updateStorageMeteringFreeDays(data) {
    try {
        return await MeteringClient.mutate({
            mutation: UPDATE_STORAGE_METERING_FREE_DAYS,
            variables: data,
        });
    }
    catch (e) {
        console.error('Error during updating Storage Metering Free Days: ', e.message);
        return { error: e };
    }
}
export async function getMeterings(sortBy, sortOrder, skip, limit, meteringInput) {
    try {
        return await MeteringClient.query({
            query: GET_METERINGS,
            variables: {
                sortBy,
                sortOrder,
                skip,
                limit,
                meteringInput,
            },
        });
    }
    catch (e) {
        console.error('Error during getMeterings: ', e.message);
        return { errors: [e] };
    }
}
export async function getMeteredAccessorials(sortBy, sortOrder, skip, limit, meteringInput) {
    try {
        return await MeteringClient.query({
            query: GET_METERED_ACCESSORIALS,
            variables: {
                sortBy,
                sortOrder,
                skip,
                limit,
                meteringInput,
            },
        });
    }
    catch (e) {
        console.error('Error during getMeteredAccessorials: ', e.message);
        return { errors: [e] };
    }
}
